/* eslint-disable default-case */
import React from 'react';
import { connect } from "react-redux";
import styles from './Settings.module.css';
import sourceTypeData from './sourceTypes';
import defaults from './defaults';
import counterTypes from './counterTypes';
import constants from '../../../../globalization';
import FireboardUtils from '../../../../util/fireboard-util';
import CommonUtil from '../../common';
import Button from '../../../../components/Button';

class Settings extends React.Component<> {
    state = {
        activeCheckFilter: '',
        filterOptions: defaults.filterSources,
        orderTypes: [],
        sourceTypes: [],
        revenueTypes: [],
        sensorGrpTypes: [],
        orderTypeNotifications: [],
        sourceTypeNotifications: [],
        revenueTypeNotifications: [],
        sensorGrpTypeNotifications: [],
        notificationTypesList: [],
        orderTypesList: defaults.orderTypesList,
        revenueCenters: defaults.revenuesList,
        sensorGroupList: defaults.sensorGroupAll,
        managerMode: false,
        counters: []

    };
    notificationTypes = [];
    deviceGroup = null;
    deviceGrpIsNotNull = false;

    componentDidMount() {
        const { reduxProps, managerMode } = this.props;
        if (managerMode) {
            this.state.managerMode = true;
        }
        const { storeInfo, deviceApi, deviceApiData } = reduxProps;

        /**
         * Remove ["MDM Policy Updated", "Device Notification", "Channel Status Update"] notification type from filter screen
         * These 3 notfification type should always be enabled
         * @Ids -
         * Channel Status Update - 16
         * MDM Policy Updated - 19
         * Device Notification - 20
         */
        const { notificationTypes: nTypes } = storeInfo?.data || {};
        this.notificationTypes = nTypes.filter(n => n.id !== 16 && n.id !== 19 && n.id !== 20);
        let updatedNotificationTypes = this.notificationTypes;
        if (!managerMode) {
            updatedNotificationTypes = updatedNotificationTypes.filter(type => type.id !== 14 && type.id !== 15);
        }
        const { deviceGroup } = deviceApi?.data || deviceApiData || {};
        this.deviceGroup = deviceGroup;
        this.deviceGrpIsNotNull = !FireboardUtils.isObjectBlank(deviceGroup);
        if (this.deviceGrpIsNotNull) {
            const {
                notificationTypeFilters,
                fireBoardSettings,
                checkChannelFilters,
                checkOrderTypeFilters,
                checkRevenueCenterFilters,
                checkSensorGroupFilters,
                notificationChannelFilters,
                notificationOrderTypeFilters,
                notificationRevenueCenterFilters,
                notificationSensorGroupFilters,
            } = deviceGroup;
            this.state.counters = CommonUtil.getCountersFromDeviceGroup(fireBoardSettings);
            this.state.activeCheckFilter = CommonUtil.getActiveFilterSourceFromDeviceGroup(fireBoardSettings);
            this.state.sourceTypes = CommonUtil.getODOrderTypes(checkChannelFilters);
            this.state.orderTypes = CommonUtil.getPOSOrderTypes(checkOrderTypeFilters, storeInfo?.data?.orderTypes);
            this.state.revenueTypes = CommonUtil.getRevenueCenterOrderTypes(checkRevenueCenterFilters, storeInfo?.data?.revenueCenters);
            this.state.sensorGrpTypes = CommonUtil.getSensorGroupOrderTypes(checkSensorGroupFilters, storeInfo?.data?.sensorGroups);
            this.state.sourceTypeNotifications = CommonUtil.getODOrderTypes(notificationChannelFilters);
            this.state.orderTypeNotifications = CommonUtil.getPOSOrderTypes(notificationOrderTypeFilters, storeInfo?.data?.orderTypes);
            this.state.revenueTypeNotifications = CommonUtil.getRevenueCenterOrderTypes(notificationRevenueCenterFilters, storeInfo?.data?.revenueCenters);
            this.state.sensorGrpTypeNotifications = CommonUtil.getSensorGroupOrderTypes(notificationSensorGroupFilters, storeInfo?.data?.sensorGroups);
            this.state.notificationTypesList = CommonUtil.getNotificationTypeNameFromDeviceGrp(notificationTypeFilters, updatedNotificationTypes);
        } else {
            const { storeTypesPersist, notificationsTypesPersist } = reduxProps;
            const { counterTypes, activeCheckFilter, sourceTypes, orderTypes, revenueTypes, sensorGrpTypes, notificationTypes } = storeTypesPersist?.data || {};
            const { sourceType: nSourceType, orderType: nOrderType, revenueCenter: nRevenueCenter, sensorGrpTypes: nSensorGrpTypes } = notificationsTypesPersist?.data || {};
            this.state.counters = counterTypes || [];
            this.state.activeCheckFilter = activeCheckFilter || 'sourceType';
            this.state.sourceTypes = Array.isArray(sourceTypes) ? sourceTypes.slice() : [];
            this.state.orderTypes = Array.isArray(orderTypes) ? orderTypes.slice() : [];
            this.state.revenueTypes = Array.isArray(revenueTypes) ? revenueTypes.slice() : [];
            this.state.sensorGrpTypes = Array.isArray(sensorGrpTypes) ? sensorGrpTypes.slice() : [];
            this.state.sourceTypeNotifications = Array.isArray(nSourceType) ? nSourceType.slice() : [];
            this.state.orderTypeNotifications = Array.isArray(nOrderType) ? nOrderType.slice() : [];
            this.state.revenueTypeNotifications = Array.isArray(nRevenueCenter) ? nRevenueCenter.slice() : [];
            this.state.sensorGrpTypeNotifications = Array.isArray(nSensorGrpTypes) ? nSensorGrpTypes.slice() : [];
            this.state.notificationTypesList = notificationTypes || [];
        }

        const { orderTypes, revenueCenters: storeInfoCenters, sensorGroups } = storeInfo.data;
        const { revenueCenters, orderTypesList, sensorGroupList } = this.state;
        this.setState({
            orderTypesList: orderTypesList.concat(orderTypes.map(ot => {
                return ot;
            })),
            revenueCenters: revenueCenters.concat(storeInfoCenters.map(rc => {
                return rc;
            })),
            sensorGroupList: sensorGroupList.concat(sensorGroups.map(sensor => sensor)),
        });
    }

    getFiltersList = () => {
        const { activeCheckFilter, orderTypesList, revenueCenters, sensorGroupList } = this.state;
        let listData = [];
        switch (activeCheckFilter) {
            case 'sourceType': {
                listData = sourceTypeData;
                break;
            }
            case 'orderType': {
                listData = orderTypesList
                break;
            }
            case 'revenueCenter': {
                listData = revenueCenters;
                break;
            }
            case 'sensorGroup': {
                listData = sensorGroupList;
                break;
            }
        }
        return listData;
    };

    getNotificationTypesList = () => {
        const { managerMode } = this.state;
        let nTypes = defaults.nTypesList.concat(this.notificationTypes);
        if (!managerMode) {
            nTypes = nTypes.filter(type => type.id !== 14 && type.id !== 15);
        }
        return nTypes;
    }

    changeFilterType = icon => {
        if (this.deviceGrpIsNotNull) return;
        const { filterOptions, activeCheckFilter } = this.state;
        this.setState({
            activeCheckFilter: activeCheckFilter !== icon.shortText ? icon.shortText : activeCheckFilter,
            filterOptions: filterOptions.map(f => {
                if (f.shortText === icon.shortText && !f.checked) {
                    return {
                        ...f,
                        checked: true,
                    };
                }
                return {
                    ...f,
                    checked: false,
                };
            }),
        });
    };

    isCheckFilterChecked = icon => {
        const { activeCheckFilter, orderTypes, sourceTypes, revenueTypes, sensorGrpTypes } = this.state;
        switch (activeCheckFilter) {
            case 'sourceType': {
                return sourceTypes.includes(icon.name);
            }
            case 'orderType': {
                return orderTypes.includes(icon.name);
            }
            case 'revenueCenter': {
                return revenueTypes.includes(icon.name);
            }
            case 'sensorGroup': {
                return sensorGrpTypes.includes(icon.name);
            }
            default: {
                return false;
            }
        }
    };

    updateCheckFilters = icon => {
        if (this.deviceGrpIsNotNull) return;
        const { name } = icon;
        const { activeCheckFilter, sourceTypes, orderTypes, revenueTypes, sensorGrpTypes, orderTypesList, revenueCenters, sensorGroupList } = this.state;
        let arr = [];
        let parentArr = [];
        let stateVar = '';
        switch (activeCheckFilter) {
            case 'sourceType': {
                arr = sourceTypes;
                parentArr = sourceTypeData;
                stateVar = 'sourceTypes';
                break;
            }
            case 'orderType': {
                arr = orderTypes;
                parentArr = orderTypesList;
                stateVar = 'orderTypes';
                break;
            }
            case 'revenueCenter': {
                arr = revenueTypes;
                parentArr = revenueCenters;
                stateVar = 'revenueTypes';
                break;
            }
            case 'sensorGroup': {
                arr = sensorGrpTypes;
                parentArr = sensorGroupList;
                stateVar = 'sensorGrpTypes';
            }
        }
        const index = arr.findIndex(t => t === name);
        let temp = arr;
        if (index === -1) {
            if (name === 'All') {
                temp = parentArr.map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === 'All') {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (arr.includes('All')) {
                    const allIndex = arr.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ [stateVar]: temp });
    };

    isNotificationFilterChecked = icon => {
        const {
            activeCheckFilter,
            orderTypeNotifications,
            sourceTypeNotifications,
            revenueTypeNotifications,
            sensorGrpTypeNotifications,
        } = this.state;
        switch (activeCheckFilter) {
            case 'sourceType': {
                return sourceTypeNotifications.includes(icon.name);
            }
            case 'orderType': {
                return orderTypeNotifications.includes(icon.name);
            }
            case 'revenueCenter': {
                return revenueTypeNotifications.includes(icon.name);
            }
            case 'sensorGroup': {
                return sensorGrpTypeNotifications.includes(icon.name);
            }
            default: {
                return false;
            }
        }
    }

    isNotificationFilterTypeChecked = n => {
        const { notificationTypesList } = this.state;
        return notificationTypesList.includes(n.name);
    };


    updateNotificaitonFilters = icon => {
        if (this.deviceGrpIsNotNull) return;
        const { name } = icon;
        const { activeCheckFilter, sourceTypeNotifications, orderTypeNotifications, revenueTypeNotifications, sensorGrpTypeNotifications, orderTypesList, revenueCenters, sensorGroupList } = this.state;
        let arr = [];
        let parentArr = [];
        let stateVar = '';
        switch (activeCheckFilter) {
            case 'sourceType': {
                arr = sourceTypeNotifications;
                parentArr = sourceTypeData;
                stateVar = 'sourceTypeNotifications';
                break;
            }
            case 'orderType': {
                arr = orderTypeNotifications;
                parentArr = orderTypesList;
                stateVar = 'orderTypeNotifications';
                break;
            }
            case 'revenueCenter': {
                arr = revenueTypeNotifications;
                parentArr = revenueCenters;
                stateVar = 'revenueTypeNotifications';
                break;
            }
            case 'sensorGroup': {
                arr = sensorGrpTypeNotifications;
                parentArr = sensorGroupList;
                stateVar = 'sensorGrpTypeNotifications';
            }
        }
        const index = arr.findIndex(t => t === name);
        let temp = arr;
        if (index === -1) {
            if (name === 'All') {
                temp = parentArr.map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === 'All') {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (arr.includes('All')) {
                    const allIndex = arr.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ [stateVar]: temp });
    };

    updateNotificationTypeFilters = (icon) => {
        if (this.deviceGrpIsNotNull) return;
        const { name } = icon;
        const { notificationTypesList } = this.state;
        const index = notificationTypesList.findIndex(t => t === name);
        let temp = notificationTypesList;
        if (index === -1) {
            if (name === 'All') {
                temp = defaults.nTypesList.concat(this.notificationTypes).map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === 'All') {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (notificationTypesList.includes('All')) {
                    const allIndex = notificationTypesList.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ notificationTypesList: temp });
    }

    saveFilterData = () => {
        const {
            sourceTypes,
            orderTypes,
            revenueTypes,
            sensorGrpTypes,
            activeCheckFilter,
            orderTypeNotifications,
            sourceTypeNotifications,
            revenueTypeNotifications,
            sensorGrpTypeNotifications,
            notificationTypesList,
            counters,
        } = this.state;
        const { setOrderType, onSaveFilter, setNotificationType, setCounterType } = this.props;
        setNotificationType && setNotificationType(notificationTypesList);

        switch (activeCheckFilter) {
            case 'sourceType': {
                setOrderType && setOrderType(sourceTypes);
                break;
            }
            case 'orderType': {
                setOrderType && setOrderType(orderTypes);
                break;
            }
            case 'revenueCenter': {
                setOrderType && setOrderType(revenueTypes);
                break;
            }
            case 'sensorGroup': {
                setOrderType && setOrderType(sensorGrpTypes);
                break;
            }
        }
        setCounterType(counters)
        onSaveFilter && onSaveFilter(activeCheckFilter, orderTypes, sourceTypes, revenueTypes, sensorGrpTypes, orderTypeNotifications, sourceTypeNotifications, revenueTypeNotifications, sensorGrpTypeNotifications, notificationTypesList, counters);
    }

    isFilterOptionChecked = opt => {
        const { activeCheckFilter } = this.state;
        return activeCheckFilter === opt.shortText;
    }

    isCounterFilterChecked = counter => {
        const { counters } = this.state;
        return counters.includes(counter.name);
    };

    getHideCounters = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Hide Counters</span>
                <div className={styles.filterWrapper}>
                    {counterTypes.map(fo => {
                        return (
                            this.isCounterFilterChecked(fo) ?
                                <div key={`checked-counter-${fo.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateCounterFilters(fo)}>
                                    <span className={styles.checkboxLableChecked}>{fo.name}</span>
                                </div>
                                :
                                <div key={`uncheckd-counter-${fo.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateCounterFilters(fo)}>
                                    <span className={styles.checkboxLable}>{fo.name}</span>
                                </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    updateCounterFilters = (icon) => {
        if (this.deviceGrpIsNotNull) return;
        const { name } = icon;
        const { counters } = this.state;
        const index = counters.findIndex(t => t === name);
        let temp = counters;
        if (index === -1) {
            console.debug('pushing', name);
            if (name === constants.orderTypeAll) {
                temp = counterTypes.map(t => t.name);
            } else {
                temp.push(name);
            }
        } else {
            if (name === constants.orderTypeAll) {
                temp = [];
            } else {
                temp.splice(index, 1);
                if (counters.includes('All')) {
                    const allIndex = counters.findIndex(t => t === 'All');
                    temp.splice(allIndex, 1);
                }
            }
        }
        this.setState({ counters: temp });

    };
    getFilterSoueces = (filterOptions) => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Filter Sources</span>
                <div className={styles.filterWrapper}>
                    {filterOptions.map(fo => {
                        return (
                            this.isFilterOptionChecked(fo) ?
                                <div key={`filter-${fo.shortText}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.changeFilterType(fo)}>
                                    <span className={styles.checkboxLableChecked}>{fo.name}</span>
                                </div>
                                :
                                <div key={`filter-${fo.shortText}`} className={styles.checkBoxWrapper} onClick={() => this.changeFilterType(fo)}>
                                    <span className={styles.checkboxLable}>{fo.name}</span>
                                </div>

                        )
                    })}
                </div>
            </div>
        )
    }
    getChecks = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Checks</span>
                <div className={styles.filterWrapper}>
                    {this.getFiltersList().map(f => {
                        return (
                            this.isCheckFilterChecked(f) ?
                                (<div key={`checkfilter-${f.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateCheckFilters(f)}>
                                    <span className={styles.checkboxLableChecked}>{f.name}</span>
                                </div>) :
                                (<div key={`checkfilter-${f.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateCheckFilters(f)}>
                                    <span className={styles.checkboxLable}>{f.name}</span>
                                </div>)
                        )
                    })}
                </div>
            </div>
        )
    }

    getNotifications = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Notifications</span>
                <div className={styles.filterWrapper}>
                    {this.getFiltersList().map(f => {
                        return (
                            this.isNotificationFilterChecked(f) ?
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateNotificaitonFilters(f)}>
                                    <span className={styles.checkboxLableChecked}>{f.name}</span>
                                </div>)
                                :
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateNotificaitonFilters(f)}>
                                    <span className={styles.checkboxLable}>{f.name}</span>
                                </div>)
                        )
                    })}
                </div>
            </div>
        )
    }

    getNotificationsFilter = () => {
        return (
            <div className={styles.filterContainer}>
                <span className={styles.textLable}>Notifications Filters</span>
                <div className={styles.filterWrapper}>
                    {this.getNotificationTypesList().map(f => {
                        return (
                            this.isNotificationFilterTypeChecked(f) ?
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxCheckedWrapper} onClick={() => this.updateNotificationTypeFilters(f)}>
                                    <span className={styles.checkboxLableChecked}>{f.name}</span>
                                </div>)
                                :
                                (<div key={`notificationfilter-${f.id}`} className={styles.checkBoxWrapper} onClick={() => this.updateNotificationTypeFilters(f)}>
                                    <span className={styles.checkboxLable}>{f.name}</span>
                                </div>)
                        )
                    })}
                </div>
            </div>
        )
    }

    render() {
        const { filterOptions } = this.state;
        const { onClose } = this.props;
        return (
            <div className={styles.container}>
                <div className={styles.heading}>FILTERS</div>
                <div className={styles.bodyContainer}>
                    {this.getHideCounters()}
                    {this.getFilterSoueces(filterOptions)}
                    {this.getChecks()}
                    {this.getNotifications()}
                    {this.getNotificationsFilter()}
                </div>
                <div className={styles.btnWrapper}>
                    <Button className={styles.btns} onClick={onClose}>CANCEL</Button>
                    <Button className={styles.btns} disabled={this.deviceGrpIsNotNull} onClick={this.saveFilterData}>SAVE</Button>
                </div>
            </div>
        );
    }
};

const mapStateToProps = reduxProps => ({
    reduxProps,
});

export default connect(
    mapStateToProps,
    null,
)(Settings);
